<template>
  <div>
    <input type="file" @change="up" />
  </div>
</template>

<script>
const heic2any = require("heic2any");
export default {
  data() {
    return {};
  },
  methods: {
    up(ev) {
      var blob = ev.target.files[0];
      heic2any({
        blob: blob,
        toType: "image/jpg"
      })
        .then(function(resultBlob) {
          console.log(resultBlob, blob.name + ".gif");
        })
        .catch(function(x) {
          console.log(x);
        });
    }
  }
};
</script>